module.exports = __webpack_public_path__ + "img/repuesto.8915c385.svg";